<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yLTZpN/tc-custom/9781250082190.jpg?1737547137391" alt="This image is the cover for the book Cannabis"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cannabis
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Along with Eric Schlosser’s </b><i><b>Reefer Madness</b></i><b>, this could become a staple at neighborhood head shops . . . the only hash book you’ll ever need.” —</b><i><b>Kirkus Reviews</b></i></p><p>To some it’s the classic “gateway drug,” to others it is a harmless way to relax, or provide relief from crippling pain. Some fear it is a dangerous drug with addictive properties; to others still it is a legal anomaly and should be decriminalized. Whatever the viewpoint, and by whatever name it is known, cannabis—or marijuana, hashish, dope, pot, weed, grass, ganja—incites debate at every level, and the effect it has on the cultures and economics of every corner of the globe is undeniable.<br/><br/>In this definitive study, Martin Booth crafts a tale of medical advance, religious enlightenment, political subterfuge and human rights; of law enforcement and custom officers, cunning smugglers, street pushers, gang warfare, writers, artists, musicians, and happy-go-lucky hippies and potheads.<br/><br/>Booth chronicles the fascinating and often mystifying process through which cannabis, a relatively harmless substance, became outlawed throughout the Western world, and the devastating effect such legislation has on the global economy. Above all, he demonstrates how the case for decriminalization remains one of the twenty-first century’s hottest topics.</p><p><b>“Amazingly informative and riveting . . . quite intoxicating.” —</b><i><b>Financial Times</b></i><b> (UK)</b><br/><br/><b>“Even-handed, adult and good-humoured . . . original and thought-provoking.” —</b><i><b>The Sunday Telegraph </b></i><b>(UK)</b><br/><br/><b>“Fascinating . . . a clear-headed and sustained case.” —</b><i><b>The Sunday Times</b></i><b> (UK)</b><br/><br/><b>“Well-researched.” —</b><i><b>The Seattle Times</b></i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Booth
      </h2>
      
      <p class="authorDescription body article"><B>Martin Booth</B> was an internationally known, Booker-prize shortlisted writer. <I>His Opium: A History </I>is regarded as the definitive book on the subject. He lived in Devon, England, at the time of his death in February 2004.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Picador
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b9fe8414